module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"deck":"Deck","tiltmeter":"Tilt.","accelerometer":"Acc.","analogNode":"Node","crackmeter":"Crack"},"it":{"deck":"Deck","tiltmeter":"Inclin.","accelerometer":"Acc.","analogNode":"Nodo","crackmeter":"Crack"}}')
  delete Component.options._Ctor
}
